export enum IconButtonTypeEnum{
    edit,
    editNew,
    delete,
    moderation,
    attachment,
    add,
    deleteRed,
}
